import { render, staticRenderFns } from "./FundManagerDetail.vue?vue&type=template&id=16ffcbf4&"
import script from "./FundManagerDetail.vue?vue&type=script&lang=js&"
export * from "./FundManagerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports